<template>
  <div>
    <vs-popup
      id="modalAddApolice"
      :active.sync="modalAddApolice"
      :title="this.modalTitle"
      class="overflow-auto"
    >
      <div class="vx-row flex px-5">
        <div class="vx-col w-full sm:mt-0 mt-4">
          <span>Número da apólice</span>
          <vs-input
            class="w-full"
            name="Número da apólice"
            v-model="form.numeroApolice"
            v-validate="{ required: true }"
            type="text"
            v-mask="'###.#.##.##.######'"
            :state="validateState('Número da apólice')"
            :danger="validateClass('Número da apólice')"
          />
        </div>
        <div class="vx-col w-full mt-4">
          <span>Grupos</span>
          <v-select
            :options="grupos"
            class="w-full"
            name="Grupos"
            id="Grupos"
            v-validate="{ required: true }"
            v-model="idGrupo"
            multiple
            @input="handleSelectAll(idGrupo)"
          ></v-select>
        </div>
      </div>

      <div class="vx-row flex px-5 my-5">
        <div class="vx-col">
          <span>Intervalo de valor FIPE</span>
        </div>
        <div class="w-full vx-col gap-4 sm:flex">
          <div class="vx-col w-full sm:w-1/2 sm:mt-0 mt-4 pb-4">
            <small>De:</small>
            <money
              class="w-full vs-inputx vs-input--input large"
              v-bind="money"
              name="Valor Fipe Inicial"
              v-model="form.valorFipeInicial"
              v-validate="{ required: true, min_value: 0 }"
              :state="validateState('Valor Fipe Inicial')"
              :danger="validateClass('Valor Fipe Inicial')"
            />
          </div>
          <div class="vx-col w-full sm:w-1/2 sm:mt-0 mt-4 pb-4">
            <small>Até:</small>
            <money
              label-placeholder="Até:"
              class="w-full vs-inputx vs-input--input large"
              v-bind="money"
              name="Valor Fipe Final"
              v-model="form.valorFipeFinal"
              v-validate="{
                required: true,
                min_value: 0,
              }"
              :state="validateState('Valor Fipe Final')"
              :danger="validateClass('Valor Fipe Final')"
            />
          </div>
        </div>
      </div>

      <div v-if="apolicesConcorrentes">
        <vs-alert color="danger"
          >Apólices já existentes com dados conflitantes:</vs-alert
        >
        <div class="flex justify-center">
          <div class="overflow-auto" style="max-height: 200px">
            <table class="table-auto">
              <thead class="text-center">
                <th class="px-4 py-2">Número da Apólice</th>
                <th class="px-4 py-2">Grupos</th>
                <th class="px-4 py-2">Valor FIPE Inicial</th>
                <th class="px-4 py-2">Valor FIPE Final</th>
              </thead>
              <tbody>
                <tr
                  v-for="(apolice, index) in apolicesConcorrentes"
                  :key="index"
                  class="text-center"
                >
                  <td>{{ apolice.numeroApolice }}</td>
                  <td>{{ apolice.grupos }}</td>
                  <td>R${{ apolice.valorFipeInicial }}</td>
                  <td>R${{ apolice.valorFipeFinal }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="vx-row flex px-5 mt-5 justify-end">
        <div class="vx-col flex gap-5">
          <vs-button
            color="warning"
            @click.stop.prevent="resetFormApolice"
            type="border"
          >
            Limpar</vs-button
          >
          <vs-button @click="submit" color="success"> Salvar </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import service from '../../services';
import { Money } from 'v-money';
import { decryptData } from '../../services/decryptData';

export default {
  props: {
    openForm: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    decoded: {
      type: Object,
    },
    apolicesConcorrentes: {
      type: Array,
    },
  },
  watch: {
    openForm() {
      if (this.openForm) {
        this.preencheSelects();
        if (this.form.idApolice) {
          this.modalTitle = 'Editar Apólice';
          return;
        }
        this.modalTitle = 'Adicionar Apólice';
      }
    },

    modalAddApolice() {
      if (!this.modalAddApolice) {
        this.emitForm ? this.$emit('saveForm') : this.$emit('closeModal');
        this.resetFormApolice();
      }
    },
  },

  data() {
    return {
      idEmpresa: null,
      grupos: [],
      idGrupo: null,
      modalAddApolice: false,
      idsGrupoExistentes: [],
      form: {
        idApolice: null,
        idUsuario: null,
        gruposAdicionados: [],
        gruposDeletados: [],
        valorFipeInicial: null,
        valorFipeFinal: null,
      },
      emitForm: false,
      money: {
        decimal: '.',
        thousands: '',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
      },
      modalTitle: null,
    };
  },
  methods: {
    /**
     * Validates the state of a form field.
     * @method
     * @param {string} ref - The reference to the form field.
     * @returns {boolean|null} - True if the field is valid, false if invalid, and null if not yet validated.
     */
    validateState(ref) {
      const isValid =
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated);
      if (isValid) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },

    /**
     * Returns the validation class for a form field.
     * @method
     * @param {string} ref - The reference to the form field.
     * @returns {boolean|null} - True if the field is invalid, false if valid, and null if not yet validated.
     */
    validateClass(ref) {
      const isValid =
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated);
      if (isValid) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    /**
     * Fetches data for select inputs from the server.
     * @param {string} model - The model name to fetch data from.
     * @param {string} array - The name of the array to store fetched data.
     * @param {string} campoDescricao - The field name to use as a label in the select options.
     * @param {string} campoPK - The field name to use as a unique identifier in the select options.
     * @returns {Promise<void>} - A promise that resolves when the data is fetched and processed, or rejects with an error.
     */
    async buscaDadosSelects(model, array, campoDescricao, campoPK) {
      this[array] = [];
      try {
        this.$vs.loading();
        let { data } = await service.getAll(
          'g',
          {},
          `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`,
        );

        data = decryptData(data);
        this[array] = data.map((element) => ({
          ...element,
          id: element[campoPK],
          label: element[campoDescricao],
        }));
        this[array].unshift({
          id: null,
          label: 'Selecionar Todos',
        });
      } catch {
        this.notify('danger', 'Falha ao buscar grupos');
      } finally {
        this.$vs.loading.close();
      }
    },

    /**
     * Resets the form fields related to a policy.
     */
    resetFormApolice() {
      this.form = {
        idApolice: null,
        gruposAdicionados: [],
        gruposDeletados: [],
        valorFipeInicial: 0,
        valorFipeFinal: 0,
      };
      this.emitForm = false;
      this.idGrupo = [];
      this.idsGrupoExistentes = [];
    },

    /**
     * Submits the form data for adding/editing a policy.
     * Validates the form fields and sends the data to the server.
     */
    async submit() {
      const isValid = await this.$validator.validateAll();
      if (!isValid) {
        this.$validator.errors.items.forEach((error) => {
          this.aguardeCadastro = false;
          this.notify('danger', error.msg);
        });
        return;
      }
      if (!this.valorFipeFinalValido()) return;

      const idsGruposSelecionados = this.idGrupo.map((grupo) => grupo.id);

      this.form.gruposAdicionados = idsGruposSelecionados.filter(
        (id) => !this.idsGrupoExistentes.includes(id),
      );

      this.form.gruposDeletados = this.idsGrupoExistentes.filter(
        (id) => !idsGruposSelecionados.includes(id),
      );

      try {
        this.$vs.loading();
        const resultApolice = await service.post(
          'apolice',
          'adicionar',
          this.form,
        );

        const { data } = resultApolice;

        if (data.length) {
          const apolicesConcorrentesFormatadas = data.map((apolice) => ({
            ...apolice,
            grupos: apolice.grupos.map((grupo) => grupo.nomeGrupo).join(', '),
          }));
          this.$emit(
            'guardaApolicesConcorrentes',
            apolicesConcorrentesFormatadas,
          );
          this.notify(
            'danger',
            'Já existe uma apólice com esse número ou grupo e faixa de preço.',
          );
          return;
        }
        this.aguardeCadastro = false;
        this.notify('success', 'Operação Realizada com sucesso');
        this.emitForm = true;
        this.modalAddApolice = false;
      } catch (error) {
        this.aguardeCadastro = false;
        this.notify('danger', error);
      } finally {
        this.$vs.loading.close();
      }
    },

    /**
     * Fetches and fills select inputs with initial data when the modal for adding/editing a policy is opened.
     */
    async preencheSelects() {
      this.buscaDadosSelects(
        'gruposVeiculos',
        'grupos',
        'nomeGrupo',
        'idGrupo',
      );
      this.modalAddApolice = true;
      this.idEmpresa = this.decoded.idEmpresa;
      this.idUsuario = this.decoded.idUsuario;
      if (this.dados) {
        this.preencheForm();
      }
    },

    /**
     * Populates the form with data for editing.
     * @method
     */
    async preencheForm() {
      this.buscaGruposApolice();
      this.form = this.dados;
    },

    /**
     * Fetches groups associated with a policy from the server.
     * Updates the existing groups and IDs of existing groups associated with the policy.
     * Displays a notification in case of failure.
     * @returns {Promise<void>} - A promise that resolves when the groups are fetched and processed, or rejects with an error.
     */
    async buscaGruposApolice() {
      try {
        const idApolice = this.dados.idApolice;
        this.$vs.loading();
        const { data } = await service.post(
          'apolice',
          'listar-grupos-apolice',
          {
            idApolice,
          },
        );
        this.idsGrupoExistentes = data.map((grupo) => grupo.idGrupo);
        this.idGrupo = this.grupos.filter((grupo) =>
          this.idsGrupoExistentes.includes(grupo.id),
        );
      } catch (error) {
        this.notify('danger', 'Falha ao listar grupos vinculados à apólice.');
      } finally {
        this.$vs.loading.close();
      }
    },

    /**
     * Handles the "Select All" option in the group selection.
     * Selects all groups when the "Select All" option is chosen.
     * @param {Array} value - The selected groups array.
     */
    handleSelectAll(value) {
      const selectAll = value.find(
        (grupo) => grupo.label === 'Selecionar Todos',
      );
      if (selectAll) {
        this.idGrupo = this.grupos.filter((grupo) => grupo.id);
      }
    },

    /**
     * Displays a notification message.
     * @param {string} color - The color of the notification (e.g., 'success', 'danger', 'warning').
     * @param {string} msg - The message to be displayed in the notification.
     * @param {number} time - The duration of the notification display (in milliseconds).
     * @returns {object} - The notification object.
     */
    notify(color, msg, time = 2500) {
      return this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: msg,
        color: color,
        time: time,
      });
    },

    /**
     * Checks if the final Fipe value is valid.
     * Displays a notification if the final value is not greater than the initial value.
     * @returns {boolean} - True if the final value is valid, false otherwise.
     */
    valorFipeFinalValido() {
      const isBigger = this.form.valorFipeFinal > this.form.valorFipeInicial;
      if (!isBigger) {
        this.notify(
          'danger',
          'Valor final precisa ser maior que o valor inicial.',
        );
      }
      return isBigger;
    },
  },
  components: {
    'v-select': vSelect,
    Money,
  },
};
</script>
<style>
#modalAddApolice .vs-popup--content {
  overflow: visible;
}
</style>
